import React, { useEffect, useState, useRef } from "react";
import { DialogActions, CircularProgress, Grid, Button, TextField } from "@mui/material";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, FormProvider } from "react-hook-form";
import { useDispatch } from "react-redux";
import CustomTextField from "../../../components/CustomTextField";
import { useDialog } from "../../../contexts/DialogContext";
import { showSuccessSnackbar, showErrorSnackbar } from "../../../redux/slices/snackbar";
import useComplaint from "../../../hooks/useComplaint";
import { useNavigate, useLocation } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";

const validationSchema = Yup.object().shape({
  comments: Yup.string().required("Required"),
});

const CloseComplaint = (props) => {
  const { unSetDialog } = useDialog();

  const { t } = useTranslation();
  const { getCustomerComplaint, customerComplaint, closeCustomerComplaint, isSubmitting } =
    useComplaint();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { complaintId, customerComplaintId, fetchData } = props;

  React.useEffect(() => {
    if (Object.keys(customerComplaint).length !== 0) {
      const initialValues = {
        complaintId: complaintId,
        customerComplaintId: customerComplaintId,
        file: null,
      };
      reset(initialValues);
    }
  }, [customerComplaint]);

  const methods = useForm({
    resolver: yupResolver(validationSchema),
  });

  const {
    reset,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
  } = methods;

  const onSubmit = async (data) => {
    try {
      await closeCustomerComplaint(data);

      dispatch(showSuccessSnackbar("Complaint closed successfully!"));
      unSetDialog("Accept");
      fetchData();
    } catch (err) {
      dispatch(showErrorSnackbar("Failed to close complaint"));
    }
  };

  const fetch = async () => {
    await getCustomerComplaint(customerComplaintId);
  };

  useEffect(() => {
    fetch();
  }, []);

  return (
    <React.Fragment>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={12} className="row" pt={8}>
            <Grid item xs={9.5} sm={12} md={8} lg={8} xl={8}>
              <CustomTextField
                label={t("comments")}
                name="comments"
                control={control}
                fullWidth
                variant="outlined"
                errors={errors}
                rows={1}
                multiline={true}
                fields={validationSchema.fields}
              />
            </Grid>
            <Grid item xs={9.5} sm={12} md={8} lg={8} xl={8}>
              <TextField
                variant="standard"
                error={false}
                fullWidth
                helperText={""}
                label="Upload file"
                margin="normal"
                name="file"
                onChange={(event) => {
                  setValue("file", event.currentTarget.files[0]);
                }}
                type="file"
              />
            </Grid>
          </Grid>
          <DialogActions>
            <Button
              disabled={isSubmitting}
              type="submit"
              variant="contained"
              color="primary"
              startIcon={<AddIcon />}
              endIcon={isSubmitting ? <CircularProgress size={24} /> : null}
            >
              Close
            </Button>

            <Button variant="text" onClick={() => unSetDialog("close_complaint")} color="primary">
              Close
            </Button>
          </DialogActions>
        </form>
      </FormProvider>
    </React.Fragment>
  );
};
export default CloseComplaint;
